<template>
  <div class="page-header-custom clear-filter" filter-color="white">
    <div
      v-if="!isLoadingTimelines && !isLoadingEvents"
      class="content text-black pt-lg-3"
    >
      <div class="centerTimePicker text-center pt-lg-1 px-lg-5">
        <div v-if="this.timelines.length > 1">
          <div
            v-for="(timeline, index) in this.timelines"
            :key="index"
            class="row mx-lg-5"
          >
            <div class="col-12">
              <div class="postcardpercorsi light orange mx-4">
                <div class="postcardpercorsi__text pt-3 mt-4">
                  <div class="h-100">
                    <h1 class="postcardpercorsi__title orange">
                      {{ timeline["geo:Titolo_it"][0]["@value"] }}
                    </h1>

                    <div class="postcardpercorsipredefiniti__bar"></div>
                    <div class="postcardpercorsi__preview-txt">
                      {{ timeline["dcterms:description"][0]["@value"] }}
                    </div>
                    <div
                      :class="{
                        'text-left mt-5': isLarge,
                        'text-center': !isLarge,
                      }"
                    >
                      <Button
                        size="small"
                        type="primary"
                        v-on:click="moreInfoTimeline(index)"
                        class="button_font mt-5"
                        >Ulteriori informazioni
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row mb-4 mx-3">
            <div class="col-12">
              <h2 class="title pt-0 mobile-title mb-2">
                {{ this.$store.getters.timelines[0]["o:title"] }}
              </h2>
              <h3 class="text-black mobile-subtitle mb-0">
                {{
                  this.$store.getters.timelines[0]["geo:Titolo_it"][0]["@value"]
                }}
              </h3>
              <h4 class="description mobile-subtitle mt-0">
                <b>
                  {{
                    this.$store.getters.timelines[0]["dcterms:description"][0][
                      "@value"
                    ]
                  }}</b
                >
              </h4>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div id="first-section1">
                <div class="container">
                  <div class="row" v-if="isLarge">
                    <div class="triangle"></div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <section
                        id="cd-timeline"
                        class="cd-container mt-0 mt-lg-5"
                      >
                        <div
                          v-for="(event, index) in correctTimelines[0]"
                          :key="index"
                          class="cd-timeline-block"
                        >
                          <div class="cd-timeline-img cd-picture">
                            <i class="fa-solid fa-calendar-clock"></i>
                          </div>

                          <div
                            class="
                              cd-timeline-content
                              service-box-content
                              pt-0
                              px-0
                            "
                          >
                            <div
                              class="
                                row
                                postcardpercorsi
                                timeline
                                orange
                                overflow-hidden
                              "
                            >
                              <div class="col-12">
                                <div
                                  v-if="event.image !== null"
                                  class="row mb-4"
                                >
                                  <div class="col-12 px-0">
                                    <a class="postcardpercorsi__img_link">
                                      <img
                                        :src="event.image"
                                        v-img="{ group: getGroupName(event) }"
                                        :alt="event.title"
                                        style="width: 100%"
                                        class="
                                          h-100
                                          postcardtimeline__img
                                          px-0
                                          mx-0
                                          rounded-top
                                        "
                                      />
                                    </a>
                                  </div>
                                </div>

                                <div class="row mt-3">
                                  <div class="col-12 mb-3 text-center">
                                    <h3 class="mb-1">{{ event.year }}</h3>
                                    <div
                                      class="
                                        postcardtimeline__bar
                                        margin-auto
                                        d-inline-block
                                      "
                                    ></div>

                                    <h2 class="mb-1">{{ event.title }}</h2>
                                    <p class="px-4">
                                      {{ event.description }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h4 slot="header" class="title title-up text-center">
        Caricamento in corso
      </h4>
      <div class="loader">
        <svg class="circular">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="5"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../store";
import Vuex from "vuex";
import { Button } from "element-ui";
import router from "../router";
import $ from "jquery";

import { config } from "../utils/config";

import { FormGroupInput } from "@/components";

const Common = require("@/Common.vue").default;

export default {
  name: "elencotimeline-page",
  bodyClass: "timeline-page",
  components: {
    [FormGroupInput.name]: FormGroupInput,
    Button,
  },

  data() {
    return {
      isLoadingTimelines: true,
      isLoadingEvents: true,
      correctTimelines: null,
      timelines: null,
      windowWidth: 0,
    };
  },

  beforeMount() {
    var self = this;

    this.$store.commit("removePOIAndActivities");

    Common.getElemsByClass(this, config.omekaIDs.omekaIDtimeline, (res) => {
      store.state.timelines = res.body;

      Common.getElemsByClass(this, config.omekaIDs.omekaIDeventi, (res) => {
        store.state.events = res.body;

        Array.prototype.forEach.call(store.state.events, (i) => {
          i.media = [];

          Common.getElementImages(this, i, (mediaList) => {
            i.media = mediaList;

            store.commit("setTimelines");
            this.correctTimelines = this.getCorrectTimelines();

            //ordine decrescente: in cima avrò l'evento meno recente
            this.correctTimelines[0].sort((a, b) =>
              a.year > b.year ? 1 : b.year > a.year ? -1 : 0
            );

            //ordine crescente: in cima avrò l'evento più recente
            //this.correctTimelines[0].sort((a,b) => (a.year < b.year) ? 1 : ((b.year < a.year) ? -1 : 0))
          });
        });

        self.isLoadingEvents = false;
      });
      self.isLoadingTimelines = false;
    });

    this.timelines = store.state.timelines;

    //TODO: SOLO PER TESTARE L'ELENCO -> decommentare questa riga se si vuole avere l'elenco di più timeline
    //this.timelines.push(this.timelines[0])
  },

  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },

  computed: {
    ...Vuex.mapGetters([]),

    isLarge() {
      return this.windowWidth >= 768;
    },
  },

  methods: {
    getGroupName(event) {
      return event.title;
    },
    getCorrectTimelines() {
      var timelines = [...Array(store.state.timelines.length)].map((x) => 0);

      Array.prototype.forEach.call(store.state.timelines, (i, index) => {
        var timeline = [];

        Array.prototype.forEach.call(i.events, (event) => {
          var date;

          if (event["geo:Data"][0]["@value"].length === 4) {
            date = new Date(event["geo:Data"][0]["@value"]);
          } else if (event["geo:Data"][0]["@value"].length > 4) {
            const [day, month, year] =
              event["geo:Data"][0]["@value"].split("/");
            date = new Date(year, month, day);
          }

          var description = event["dcterms:description"][0]["@value"];

          var e = {
            from: date,
            year: date.getFullYear(),
            title: event["geo:Titolo_it"][0]["@value"],
            showDayAndMonth: true,
            description: description,
          };

          if (event["media"] !== undefined && event["media"].length > 0) {
            e.image = event["media"][0]["o:thumbnail_urls"]["large"];
            event.image = event["media"][0]["o:thumbnail_urls"]["large"];
          } else {
            e.image = null;
            event.image = null;
          }

          timeline.push(e);
        });

        timelines[index] = timeline;
      });

      return timelines;
    },

    moreInfoTimeline(index) {
      router.push({
        name: "timeline",
        params: {
          index,
        },
      });
    },
  },
};
</script>
<style>
.page-header-custom {
  min-height: 100%;
  padding: 0;
  color: #ffffff;
  position: relative;
  overflow: hidden;
  align-items: center;
  text-align: center;
}
</style>
